module.exports = __webpack_public_path__ + "img/case-hebgydx.abb78511.png";